import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const LinkBoxGridStyles = makeStyles((theme) => ({
  container: {
    padding: "10px 20px 1rem",
    color: COLORS.DARK_GRAY_2,
    fontSize: "1.15rem"
  },
  linkBoxContainer: {
    display: "flex"
  },

  childrenList: {
    lineHeight: "1.25rem",
    fontWeight: "normal",
    paddingLeft: "1rem",
    fontSize: "1.15rem",
    marginTop: ".25rem"
  },
  gridSpacing: {
    marginTop: "1rem"
  },
  sectionDivider: {
    borderTop: `2px solid ${COLORS.GRAY}`,
    width: "95%",
    marginTop: "1rem",
    marginBottom: "0.5rem"
  },
  subheading: {
    width: "95%",
    display: "flex",
    marginTop: ".5rem",
    marginBottom: ".75rem",
    fontWeight: 600,
    fontSize: "1.875rem",
    fontFamily: "Inter, sans-serif",
    color: COLORS.DARK_GRAY_2
  },
  linkBox: {
    width: "95%",
    paddingBottom: "1rem",
    fontSize: "1.15rem",
    lineHeight: "1.5rem"
  },
  link: {
    color: COLORS.DARK_GRAY_2,
    marginBottom: ".5rem",
    display: "block",
    lineHeight: "normal",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  summary: {
    color: COLORS.BLACK,
    fontWeight: 400,
    marginBottom: ".5rem",
    display: "block",
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }
}));

export default LinkBoxGridStyles;
